import { BackIcon } from "@/components/icons";
import {
  Flex,
  Box,
  Image,
  Text,
  DrawerBody,
  DrawerContent,
  Drawer,
  DrawerOverlay,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import SuccessIcon from "./assets/success.png";
import { LogsButton } from "@/components/Button";
import { useEffect, useState } from "react";
import usePublicClient from "@/hooks/usePublicClient";
import { keccak256, toBytes } from "viem";
import { formatAmount } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";
import { TransferTopic } from "@/constants/topics";
import { Order } from "@/api/order";
import CloseIcon from "./assets/close.png";

const WithdrawComplete = ({
  order,
  isOpen,
  onClose,
}: {
  order: Order | null;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const publicClient = usePublicClient();

  // const handleCheckTx = async () => {
  //   const receipt = await publicClient.getTransactionReceipt({
  //     hash: txHash as `0x${string}`,
  //   });

  //   const transferLog = receipt.logs.find((log) => {
  //     // 这里需要填入 RequestCreated 事件的实际 topic0
  //     return log.topics[0] === TransferTopic;
  //   });

  //   if (transferLog) {
  //     const from = transferLog.topics[1];
  //     const to = transferLog.topics[2];
  //     const value = BigInt(transferLog.data).toString();
  //     setTxDetail({ from, to, value });
  //   }
  // };

  // useEffect(() => {
  //   if (!txHash) {
  //     return;
  //   }
  //   handleCheckTx();
  // }, [txHash]);

  return (
    <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent
        sx={{
          background: "#fff",
          padding: "38px 0 30px",
          borderRadius: "20px 20px 0 0",
        }}
      >
        <DrawerBody sx={{ padding: 0 }}>
          <Flex flexDir={"column"} alignItems={"center"}>
            <Image
              src={SuccessIcon}
              sx={{
                width: "58px",
                height: "58px",
              }}
            ></Image>
            <Image
              onClick={onClose}
              src={CloseIcon}
              sx={{
                width: "16px",
                height: "16px",
                position: "absolute",
                top: "20px",
                right: "20px",
              }}
            ></Image>
            <Text
              sx={{
                color: "#333",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 700,
                marginTop: "15px",
              }}
            >
              Withdraw has been completed
            </Text>
            <Text
              sx={{
                color: "#333",
                textAlign: "center",
                fontSize: "50px",
                fontWeight: 900,
                fontFamily: "DIN-Black",
                marginTop: "12px",
              }}
            >
              {formatAmount(order?.recipientAmount ?? "0", usdcInfo.decimals)}
            </Text>
            <Text
              sx={{
                color: "#333",
                textAlign: "center",
                fontSize: "32px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              USD
            </Text>
            <Text
              sx={{
                marginTop: "16px",
                color: "#848484",
                textAlign: "center",
                fontSize: "12px",
                fontWeight: 700,
              }}
            >
              {" "}
              You will receive money in your wallet
            </Text>
            <LogsButton
              sx={{
                marginTop: "20px",
              }}
              onClick={() => navigate(`/withdraw/receipt/${order?.id}`)}
            >
              <Text
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                }}
              >
                View Receipts
              </Text>
            </LogsButton>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default WithdrawComplete;
